import { Controller } from '@hotwired/stimulus';

// A link that also copies: one tap puts the address on the clipboard and the
// browser follows the link to the app's settings page (new tab), where the
// person only pastes. A toast says it was copied, because the tab that stole
// the focus will not.
//
//   <a href="https://chatgpt.com/plugins" target="_blank" data-controller="copy-open"
//      data-copy-open-text-value="https://…/mcp" data-copy-open-done-value="Copied"
//      data-action="click->copy-open#go">
//
// The click is never prevented: the copy starts inside the same gesture the
// navigation needs. Registered as "copy-open" by registerJane (register.js).
export default class extends Controller {
  static values = { text: String, done: String };

  go() {
    this.write(this.textValue);
    const toast = document.createElement('div');
    toast.className = 'toast toast-center';
    toast.innerHTML = '<div role="status" class="alert alert-success"><span></span></div>';
    toast.querySelector('span').textContent = this.doneValue;
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 4000);
  }

  write(text) {
    navigator.clipboard.writeText(text).catch(() => {
      const area = document.createElement('textarea');
      area.value = text;
      area.style.cssText = 'position:fixed;opacity:0';
      document.body.appendChild(area);
      area.select();
      document.execCommand('copy');
      area.remove();
    });
  }
}
